import { configureStore } from "@reduxjs/toolkit";
import zipInfoSlice from "./slices/zipInfo";
import funnelInfoSlice from "./slices/funnelInfo";
import globalPrivacyPolicyInfoSlice from "./slices/globalPrivacyPolicyInfo";
import reclaimModeSlice from "./slices/reclaimMode";
import otpSlice, { saveOtpSession } from "./slices/otpSlice";

export const store = configureStore({
  reducer: {
    funnelInfo: funnelInfoSlice,
    zipInfo: zipInfoSlice,
    globalPrivacyPolicyInfo: globalPrivacyPolicyInfoSlice,
    reclaimMode: reclaimModeSlice,
    otp: otpSlice
  }
});

// ── Persist OTP state to sessionStorage on every state change ─────────────────
// Only runs saveOtpSession when otp slice actually changed (reference check)
// so it doesn't affect performance of other slices.
let previousOtp = store.getState().otp;
store.subscribe(() => {
  const currentOtp = store.getState().otp;
  if (currentOtp !== previousOtp) {
    saveOtpSession(currentOtp);
    previousOtp = currentOtp;
  }
});
